<template>
  <Layout
    :title="meta.title"
    max-width="100%"
  >
    <div class="is-card mb-6">
      <base-tab
        v-model="currentStep"
        :arr="steps"
        :completed-steps="completedSteps"
        version="v2"
        box=""
        arr-prop="name"
        complete-effect
      />

      <div class="column">
        <component
          :is="steps[currentStep].component"
          :account-data="accountData"
          class="step"
          @next="handleNextStep"
          @back="goBack"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
/** Core */
import { mapActions, mapState } from 'vuex';

/** Utils */
import seo from '@/utils/seo';
import { handler as handlerError } from '@/utils/message';

/** Mixins */
import loadingMixin from '@/mixins/loadingView.mixin';
import roleManagerMixin from '@/mixins/roleManager.mixin';

/** Services */
import {
  clientsAPI,
} from '@/services';

export default {
  name: 'CGVPreConsultForm',
  components: {
    Layout: () => import('@/layouts/Layout.vue'),
    BaseTab: () => import('@/components/BaseTab.vue'),
    BaseDropmenu: () => import('@/components/BaseDropmenu.vue'),
  },
  mixins: [loadingMixin, roleManagerMixin],
  data() {
    return {
      meta: {
        title: 'Nova Simulação',
      },
      accountData: {},
      currentStep: 0,
      completedSteps: [],
      menuHelpConfig: {
        title: 'Passo a passo',
        text: `
          Acompanhe o passo a passo de como realizar uma nova simulação de CGV no <strong>Prata Digital</strong>.
        `,
        options: [
          {
            title: 'Dados pessoais do cliente',
            text: 'Insira o CPF do seu cliente, preencha os dados solicitados, eles serão usados para identificá-lo. Certifique que o campo <strong>telefone celular</strong> e <strong>e-mail</strong> corresponda ao cliente, pois a comunicação final será feita diretamente com a BMP e é imprescindível que o titular da proposta o responda.',
          },
          {
            title: 'Dados de veículo',
            text: `
              Preencha os dados conforme descrito do documento do carro do seu cliente, esses dados serão usados para consulta da tabela FIPE, utilizada como base do crédito cedido.
            `,
          },
          {
            title: 'Laudo de Vistoria',
            text: `
              Insira o último documento de vistoria realizado no veículo, ele precisa estar dentro da validade (pode variar entre 30 e 60 dias).
            `,
          },
          {
            title: 'Simulação',
            text: `
              A simulação será a base dessa proposta, simule novos valores e escolhe a parcela desejada pra continuar
            `,
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      stateConsult: (state) => state.consult.consult,
      token: (state) => state.app.logonToken,
    }),
    steps() {
      return [
        {
          name: 'Informações pessoais',
          component: () => import('@/components/CGVPreConsult/BasicDataFilled.vue'),
        },
        {
          name: 'Dados do veículo',
          component: () => import('@/components/CGVPreConsult/VehicleData.vue'),
        },
        {
          name: 'Simulação',
          component: () => import('@/components/CGVPreConsult/SimulationData.vue'),
        },
      ];
    },
  },
  async mounted() {
    if (this.stateConsult.document) await this.getAccount();
  },
  methods: {
    ...mapActions({
      setConsult: 'consult/SET_CONSULT',
    }),

    // API
    async handleNextStep(formData) {
      await this.handleMerge(formData);
      const previousStep = this.currentStep;
      const newStep = this.currentStep + 1;

      this.currentStep = newStep;

      if (!this.completedSteps.includes(previousStep)) {
        this.completedSteps.push(previousStep);
      }

      if (!this.completedSteps.includes(newStep)) {
        this.completedSteps.push(newStep);
      }
    },
    goBack() {
      if (this.currentStep === 0) {
        this.$router.push({ name: 'cgv-consult' });
      } else {
        this.currentStep -= 1;
      }
    },
    handleMerge(data) {
      this.setConsult({
        ...this.stateConsult,
        ...data,
      });
    },
    // API
    getAccount() {
      this.loading = true;

      clientsAPI.checkUniqueAccount({ document: this.stateConsult.document })
        .then(({ data }) => {
          const account = {
            ...data.data,
          };
          this.accountData = account;

          this.setConsult({
            account,
            ...this.stateConsult,
          });
        })
        .catch((err) => {
          handlerError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  metaInfo() {
    return seo.meta(this.meta);
  },
};
</script>

<style lang="scss" scoped>
.is-card {
  padding-bottom: 48px;
}

@media only screen and (min-width: 1024px) {
  .is-card {
    padding-bottom: 24px;
  }
}
</style>
